import script from "./arrivals.vue?vue&type=script&setup=true&lang=js"
export * from "./arrivals.vue?vue&type=script&setup=true&lang=js"

import "./arrivals.vue?vue&type=style&index=0&id=3ccdacac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccdacac"]])

export default __exports__